import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const PrivateRouteAdmin = ({ children }) => {
    
    const tokenAdmin = useSelector(state => state.token.tokenAdmin);
    const token = localStorage.getItem('token');

    const isTokenExpired = (token) => {
        if (!token) return true;

        const decodedToken = jwtDecode(token);
        const expirationDate = new Date(decodedToken.exp * 1000);
        return expirationDate < new Date();
    };
    
    const isAuthenticated = () => {
        return token === tokenAdmin && !isTokenExpired(token);
    };

    if (!isAuthenticated()) {
        return <Navigate to="/admin" replace />;
    };

    return children;
};

export default PrivateRouteAdmin;

